import { translate } from "@/plugins/i18n";
import type BaseEnumType from "../../baseEnumType";
import Key from "@/app/types/common/key";
import { Maybe } from "@/components/utils/typeHelpers";


export class EnumFileType implements BaseEnumType {
  private static allValues: EnumFileType[] = []; // make sure this is top-most
  
  public static image = new EnumFileType(0, "Image", "enum_file_type_image");
  
  public key: number;
  public value: string;
  public translationKey: string;

  private constructor(key: number, value: string, translationKey: string) {
    this.key = key;
    this.value = value;
    this.translationKey = translationKey;
    EnumFileType.allValues.push(this);
  }

  public get translation() { return translate(Key.fromString(this.translationKey)); }

  public isImage() { return this === EnumFileType.image; }

  public static getValues(): readonly EnumFileType[] {
    return EnumFileType.allValues;
  }

  public static getValuesExcept0(): readonly EnumFileType[] {
    return EnumFileType.allValues.filter((x) => x.key !== 0);
  }

  public static getByKey(key: number): EnumFileType {
    const found = EnumFileType.allValues.find(e => e.key === key);
    if (found === undefined) {
      throw new Error(`EnumFileType - Key not found: ${ key }`);
    }

    return found;
  }

  public static getByValue(name: string, def?: EnumFileType): EnumFileType {
    const found = name ? EnumFileType.allValues.find(e => e.value.toLowerCase() === name.toLowerCase()) : null;
    if (!found) {
      if (def) {
        return def;
      }
      throw new Error(`EnumFileType - Value not found: ${ name }`);
    }

    return found;
  }

  public equals(other: Maybe<EnumFileType>): boolean {
    return this.key === other?.key;
  }
}